const ITEMS = [
  "General Plumbing",
  "Hot Water Service",
  "Gas Fitting & Repairs",
  "CCTV Drain Camera",
  "High-Pressure Water Jetter",
  "Drainage",
  "Water Filtration",
  "Renovations",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div data-testid="services-marquee" className="bg-[#111111] text-[#F2F2F0] overflow-hidden border-b border-[#111111]">
      <div className="animate-marquee flex whitespace-nowrap py-5 w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-display uppercase tracking-wide text-xl md:text-2xl">
                <span className="px-8">{item}</span>
                <span className="w-2 h-2 bg-[#003BFF] rotate-45 inline-block" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
